import styled from 'styled-components';

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  padding: 2rem 2.4rem;
  border-radius: var(--r-md);

  p {
    font-weight: 700;
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Balance = styled.h1`
  color: var(--ink);
  font-variant-numeric: tabular-nums;
`;

const Headline = styled.h2`
  margin: 2rem 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  margin-left: 5rem;

  button:not(:last-child) {
    margin-right: 1rem;
  }

  @media (max-width: 720px) {
    margin-top: 2rem;
    margin-left: 0;
  }
`;

export { Header, Balance, Headline, ButtonsContainer };
